import ApiClass from '../../services/Api';
export const LOGIN = "LOGIN";
export const SET_ORGANISATION = "SET_ORGANISATION";
export const SET_IS_OTP_SENT = "SET_IS_OTP_SENT";
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const PREV_URL = "PREV_URL";
export const STEP = "STEP";
export const SET_OTP_VERIFIED = "SET_OTP_VERIFIED";
export const SET_INTRO_STEPS = "SET_INTRO_STEPS";
export const SET_GAME_INTRO_STEPS = "SET_GAME_INTRO_STEPS";
export const SET_GAME_ID = "SET_GAME_ID";
export const SET_SHOW_DICE_BTN = "SET_SHOW_DICE_BTN";
export const SET_GAME_STATE = "SET_GAME_STATE";
export const SET_VALUE_BUDDY_CHOOSEN = "SET_VALUE_BUDDY_CHOOSEN";
export const STORE_SELECTED_TOKEN = "STORE_SELECTED_TOKEN";
export const SET_CORRECT_VALUE_BUDDIES = "SET_CORRECT_VALUE_BUDDIES";
export const SET_TOKENS = "SET_TOKENS";
export const SET_GATE_POSITIONS = "SET_GATE_POSITIONS"
export const SET_TIMER = "SET_TIMER";
export const SET_PAUSE_GAME = "SET_PAUSE_GAME"
export const SET_REMAINING_TIME = "SET_REMAINING_TIME";
export const SET_TIMER_ID = "SET_TIMER_ID";
export const ADD_INTERVAL = 'ADD_INTERVAL';
export const CLEAR_ALL_INTERVALS = 'CLEAR_ALL_INTERVALS';
export const CHOOSE_VALUE_BUDDY_MODAL = "CHOOSE_VALUE_BUDDY_MODAL";
export const SET_FEEDBACK_QUESTIONS = "SET_FEEDBACK_QUESTIONS";
export const SET_POLL_QUESTIONS = "SET_POLL_QUESTIONS";
export const PLAY_AUDIO = "PLAY_AUDIO";

export const setLogin = (val) => ({
  type: LOGIN,
  val
})

export const setOrganisation = (val) => ({
  type: SET_ORGANISATION,
  val
})


export const setIsOtpSent = (val) => ({
  type: SET_IS_OTP_SENT,
  val
})

export const setOtpVerified = (val) => ({
  type: SET_OTP_VERIFIED,
  val
})
export const setUserInfo = (val) => ({
  type: SET_USER_INFO,
  val
})

export const setUserDetails = (val) => ({
  type: SET_USER_DETAILS,
  val
})
export const setPrevUrl = (val) => ({
  type: PREV_URL,
  val
})

export const setStep = (val) => ({
  type: STEP,
  val
})

export const setIntroSteps = (val) => ({
  type: SET_INTRO_STEPS,
  val
})
export const setGameIntroSteps = (val) => ({
  type: SET_GAME_INTRO_STEPS,
  val
})

export const setGameId = (val) => ({
  type: SET_GAME_ID,
  val
})

export const setShowDiceBtn = (val) => ({
  type: SET_SHOW_DICE_BTN,
  val
})
export const setGameState = (val) => ({
  type: SET_GAME_STATE,
  val
})
export const setCorrectValueBuddies = (val) => ({
  type: SET_CORRECT_VALUE_BUDDIES,
  val
})

export const setTokens = (val) => ({
  type: SET_TOKENS,
  val
})
export const setGatePositions = (val) => ({
  type: SET_GATE_POSITIONS,
  val
})


export const setValueBuddyChoosen = (val) => ({
  type: SET_VALUE_BUDDY_CHOOSEN,
  val
})

export const setTimer = (val) => ({
  type: SET_TIMER,
  val
})

export const pauseGame = (val) => ({
  type: SET_PAUSE_GAME,
  val
})

export const setRemainingTime = (val) => ({
  type: SET_REMAINING_TIME,
  val
})

export const setTimerId = (val) => ({
  type: SET_TIMER_ID,
  val
})

export const addInterval = (val) => ({
  type: ADD_INTERVAL,
  val
});

export const clearAllIntervals = () => ({
  type: CLEAR_ALL_INTERVALS
});

export const setChooseValueModal = (val) => ({
  type: CHOOSE_VALUE_BUDDY_MODAL,
  val
})


export const setFeedbackQuestions = (val) => ({
  type: SET_FEEDBACK_QUESTIONS,
  val
})



export const setPollQuestions = (val) => ({
  type: SET_POLL_QUESTIONS,
  val
})


export const playAudio = (val) => ({
  type: PLAY_AUDIO,
  val
})
export const handleRestart = () => (dispatch, getState) => {
  dispatch(setGameState())
  dispatch(setGameId())
  dispatch(setGameIntroSteps(0))
  dispatch(setStep(-1))
  dispatch(setValueBuddyChoosen(false))
  dispatch(setShowDiceBtn(true))
}

export const register = (param, successCallback, callback) => (dispatch, getState) => {
  const userInfo = getState().SeTu?.userInfo;
  const suborganisationId = getState()?.SeTu?.organisation?.id
  console.log('from register', param)
  userInfo['otp'] = param.otp;
  userInfo['suborganisationId'] = suborganisationId;
  ApiClass.post("/user/register").params(userInfo).send((response, err) => {

    if (response) {
      dispatch(setIsOtpSent())
      dispatch(setUserInfo())
      successCallback()

    } else {
      callback()
    }

  });
};

export const resendOtp = (successCallback) => (dispatch, getState) => {
  const uniqueId = getState()?.SeTu?.userInfo?.uniqueId;
  const newUser = getState()?.SeTu?.userInfo?.hasOwnProperty("name");
  const orgId = getState().SeTu?.organisation?.id;
  ApiClass.post("/user/sendOTP").params({ uniqueId, newUser: newUser == true, orgId }).send((response, err) => {
    console.log('from action', response, err)
    if (err) {
      dispatch(setIsOtpSent())
    }

    if (response) {
      dispatch(setIsOtpSent({ otpSent: true, timer: 30 }))
      successCallback()
    }

  });
};

export const sendOtp = (params, successCallback) => (dispatch, getState) => {

  const orgId = getState().SeTu?.organisation?.id;
  const payload = {
    orgId,
    uniqueId: params?.uniqueId,
    newUser: params?.newUser
  }

  ApiClass.post("/user/sendOTP").params(payload).send((response, err) => {
    console.log('from action', response, err)
    if (err) {
      dispatch(setIsOtpSent())
      return
    }

    if (response) {
      dispatch(setIsOtpSent({ otpSent: true, timer: 30 }))
      dispatch(setUserInfo(params))
      successCallback()
    }

  });
};

export const verifyOtp = (params, successCallback) => (dispatch, getState) => {
  const uniqueId = getState().SeTu?.userInfo?.uniqueId;
  params['uniqueId'] = uniqueId;
  const suborgId = getState().SeTu?.organisation?.id;
  params["suborgId"] = suborgId;

  ApiClass.post("/user/verifyOTP").params(params).send((response, err) => {
    console.log('from action', response, err)

    if (response) {
      dispatch(setIsOtpSent())
      dispatch(setOtpVerified(true))
      successCallback()
    }

  });
};

export const login = (params, successCallback) => (dispatch, getState) => {
  const suborgId = getState().SeTu?.organisation?.id;
  params["suborgId"] = suborgId;
  ApiClass.post("/user/login").params(params).send((response, err) => {


    if (response) {

      dispatch(setLogin(response?.token))
      ApiClass.header(response?.token)
      successCallback(response?.firstTimeUser)
    }

  });
};

export const checkOrganisation = (params, successCallback, callback) => (dispatch, getState) => {
  const { id } = params;

  // Helper function to append the base URL to all items in an object or array
  function appendBaseUrl(obj, baseUrl) {
    if (Array.isArray(obj)) {
      return obj.map(item => (typeof item === 'object' && item !== null ? appendBaseUrl(item, baseUrl) : baseUrl + item));
    } else if (typeof obj === 'object' && obj !== null) {
      for (let key in obj) {
        if (obj[key] !== null && typeof obj[key] === 'string' && obj[key]?.startsWith('uploads/')) {
          obj[key] = baseUrl + obj[key];
        }
      }
      return obj;
    }
    return baseUrl + obj;
  }

  // Function to update tokenCard with base URL and tokenCardAssets
  function updateTokenCard(tokenCard, tokenCardAssets, baseUrl, tokenIconAssets) {
    return tokenCard.map((card, index) => {
      if (tokenCardAssets[index]) {
        card.card = baseUrl + tokenCardAssets[index];
        card.image = baseUrl + tokenIconAssets[index];
      }
      return card;
    });
  }

  // Function to update tokenIcon with base URL and tokenIconAssets
  function updateTokenIcon(tokenIcon, tokenIconAssets, baseUrl) {
    return tokenIcon.map((icon, index) => {
      if (tokenIconAssets[index]) {
        icon.image = baseUrl + tokenIconAssets[index];
      }
      return icon;
    });
  }

  // Function to preload images
  function preloadImages(urls) {
    urls.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }

  // API call to fetch organization data
  ApiClass.get(`/suborganisation/check?id=${id}`).send((response, err) => {
    dispatch(setLogin()); // Dispatch login action
    console.log("from action ", response, "data", err)
    if (response) {
      const baseUrl = ApiClass._test_url + "/"; // Define the base URL
      dispatch(setOrganisation(response)); // Dispatch organization data

      const state = getState().SeTu; // Get the current state

      // Update state with the fetched assets
      state.assets = response?.introAssets?.map(img => baseUrl + img);
      successCallback(); // Call the success callback

      state.valueBuddiesImg = state?.valueBuddiesImg?.map((ele, index) => {
        index = index * 4;
        ele.image = baseUrl + response?.valueBuddyAssets[index + 0];
        ele.happy = baseUrl + response?.valueBuddyAssets[index + 1];
        ele.sad = baseUrl + response?.valueBuddyAssets[index + 2];
        ele.thumbsUp = baseUrl + response?.valueBuddyAssets[index + 3];
        ele.withName = baseUrl + response?.valueBuddyAssets[index + 0];
        return ele;
      });

      // Append base URL to various asset arrays
      state.gameAssets = appendBaseUrl(response?.gameAssets, baseUrl);
      state.utilAssets = appendBaseUrl(response?.utilAssets, baseUrl);
      state.diceAssets = appendBaseUrl(response?.diceAssets, baseUrl);
      state.tokenIconAssets = appendBaseUrl(response?.tokenIconAssets, baseUrl);
      state.audioAssets = appendBaseUrl(response?.audioAssets, baseUrl);
      state.chroAssets = appendBaseUrl(response?.chroAssets, baseUrl);
      state.valueBuddyDesc = response?.valueBuddyDesc

      // Update tokenCard and selectTokens using tokenCardAssets and tokenIconAssets
      state.tokenCard = updateTokenCard(state.tokenCard, response?.tokenCardAssets, baseUrl, response?.tokenIconAssets);
      state.selectTokens = updateTokenIcon(state.selectTokens, response?.tokenIconAssets, baseUrl);


      // Preload all the images
      const allAssets = [
        ...response?.introAssets,
        ...response?.valueBuddyAssets,
        ...response?.gameAssets,
        ...response?.utilAssets,
        ...response?.diceAssets,
        ...response?.tokenIconAssets,
        ...response?.tokenCardAssets,
        ...response?.valueBuddyDesc
      ].map(asset => baseUrl + asset);

      preloadImages(allAssets);
    }
    else if (err) {
      callback(); // Call the error callback
      return;
    }
  });
};




export const checkUserName = (params, successCallback, callback) => (dispatch, getState) => {
  const suborgId = getState().SeTu?.organisation?.id;
  ApiClass.get(`/user/checkUserName/${suborgId}/${params.username}`).send((response, err) => {


    if (response) {
      successCallback(response.exists)
    } else {
      callback(err)
    }


  });
};

export const updatePassword = (params, successCallback) => (dispatch, getState) => {
  const uniqueId = getState().SeTu?.userInfo?.uniqueId;
  params['uniqueId'] = uniqueId;
  const suborgId = getState().SeTu?.organisation?.id;
  params["suborgId"] = suborgId;
  ApiClass.patch("/user/updatePassword").params(params).send((response, err) => {

    if (response) {
      dispatch(setIsOtpSent())
      dispatch(setOtpVerified())
      dispatch(setUserInfo())
      successCallback()
    }

  });
};



export const overView = (successCallback, callback) => (dispatch, getState) => {

  ApiClass.get(`/user/overview`).send((response, err) => {

    if (err) {

      callback()
      return
    }
    if (response) {
      dispatch(setStep(response?.step))
      dispatch(setCorrectValueBuddies(response?.correctValueBuddies))
      dispatch(setTokens(response?.tokens))

      dispatch(setGatePositions(response?.gatePositions))
      dispatch(setUserDetails({ name: response?.name, username: response?.username, email: response?.email, phone: response?.phone, city: response?.city }))
      successCallback(response?.step)

      if (response?.valueBuddies) {
        getState().SeTu.valueBuddiesImg = getState().SeTu?.valueBuddiesImg?.map((ele, index) => {
          return {
            ...ele,
            name: response?.valueBuddies[index]

          }
        })
      }
      if (response?.tokens) {

        getState().SeTu.selectTokens = getState().SeTu?.selectTokens?.map((ele, index) => {
          return {
            ...ele,
            name: response?.tokens[index]

          }
        })
      }

    }



  });
};

export const fetchGameState = (successCallback, callback) => (dispatch, getState) => {

  ApiClass.get(`/game/get-data`).send((response, err) => {
    console.log('from action==>', response, err)
    if (err) {

      callback()
      return
    }
    if (response) {


      if (response.gameState) {
        dispatch(setGameState(response.gameState))

        dispatch(setGameId(response.gameState?.GameId))

        // dispatch(setStep(response?.gameState?.step))   /// by passing select player untill multiplayer
        dispatch(setStep(response?.gameState?.step == 1 ? 2 : response?.gameState?.step))

        dispatch(setValueBuddyChoosen(response?.gameState?.isValueBuddySelected))

        if (!response?.gameState?.isValueBuddySelected) {
          dispatch(setGameIntroSteps(0));
        } else if (!response?.gameState?.selectedToken) {
          dispatch(setGameIntroSteps(1));
        }
        else if (response?.gameState?.isValueBuddySelected && response?.gameState?.selectedToken) {
          dispatch(setGameIntroSteps(4));
        }

      } else if (response.step) {
        dispatch(setStep(response?.step));
        dispatch(setGameId())
        dispatch(setGameState())
        dispatch(setGameIntroSteps(0));
        dispatch(setValueBuddyChoosen(false))
      }


      successCallback()


    }



  });

};

export const gameStart = (successCallback, callback) => (dispatch, getState) => {

  ApiClass.post(`/game/start`).send((response, err) => {


    if (response?.gameId) {
      dispatch(setGameId(response.gameId))
      setRemainingTime(1)
      successCallback()
    } else {
      callback()
    }


  });
};

export const setGameType = (successCallback, callback) => (dispatch, getState) => {

  const gameId = getState().SeTu?.gameId
  ApiClass.post(`/game/set-gametype`).params({ gameType: 'single', gameId }).send((response, err) => {

    if (response) {
      successCallback()
    } else {
      callback()
    }


  });
}


export const selectToken = (params, successCallback, callback) => (dispatch, getState) => {

  const gameId = getState().SeTu?.gameId
  params['gameId'] = gameId;
  ApiClass.post(`/game/select-token`).params(params).send((response, err) => {

    if (response) {
      successCallback()
    } else {
      callback()
    }


  });
}



export const selectValueBuddies = (params, successCallback, callback) => (dispatch, getState) => {

  const gameId = getState().SeTu?.gameId;
  params['gameId'] = gameId

  ApiClass.post(`/game/valuebuddy-check`).params(params).send((response, err) => {

    if (response) {
      successCallback()
    } else {
      callback()
    }


  });
}

export const getFeedbackQuestions = (successCallback, callback) => (dispatch, getState) => {

  const suborgId = getState().SeTu?.organisation?.id;
  const learningCardData = getState().SeTu?.learningCardData

  ApiClass.get(`/feedback/questions`).params({ suborgId }).send((response, err) => {

    if (response) {
      let feedbackData = []
      for (let i = 0; i < response?.length; i++) {
        feedbackData.push({
          ...learningCardData[i],
          id: response[i].id,
          question: response[i].question,
        })
      }
      dispatch(setFeedbackQuestions(feedbackData))

      successCallback(feedbackData)
    } else {
      callback()
    }


  });
}




export const saveFeedback = (params, successCallback, callback) => (dispatch, getState) => {

  const suborgId = getState().SeTu?.organisation?.id;
  const gameId = getState().SeTu?.gameId;
  params['suborgId'] = suborgId
  params['gameId'] = gameId
  ApiClass.post(`/feedback/saveResponse`).params(params).send((response, err) => {

    if (response) {

      successCallback(response)
    } else {
      callback()
    }


  });
}

export const getPollQuestions = (successCallback, callback) => (dispatch, getState) => {

  const suborgId = getState().SeTu?.organisation?.id

  ApiClass.get(`/poll/questions`).params({ suborgId }).send((response, err) => {

    if (response) {
      console.log("res", response)
      dispatch(setPollQuestions(response))
      successCallback(response)
    } else {
      callback()
    }


  });
}

export const savePoll = (params, successCallback, callback) => (dispatch, getState) => {

  const suborgId = getState().SeTu?.organisation?.id;
  const gameId = getState().SeTu?.gameId;
  params['suborgId'] = suborgId
  params['gameId'] = gameId
  ApiClass.post(`/poll/saveResponse`).params(params).send((response, err) => {

    if (response) {

      successCallback()
    } else {
      callback()
    }


  });
}


export const endGame = (successCallback, callback) => (dispatch, getState) => {

  const gameId = getState().SeTu?.gameId;

  ApiClass.post(`/game/end-game`).params({ gameId }).send((response, err) => {

    if (response) {
      successCallback()
    } else {
      callback()
    }


  });
}
export const getLeaderBoardData = (successCallback, callback) => (dispatch, getState) => {

  const subOrgId = getState().SeTu?.organisation?.id;

  ApiClass.get(`/suborganisation/leader-board?suborgId=${subOrgId}`).params({}).send((response, err) => {

    if (response) {
      successCallback(response)
    } else {
      callback()
    }


  });
}
